import styled from "@emotion/styled";
import { logEvent } from "@firebase/analytics";
import { useInView } from "framer-motion";
import { AnimatePresence } from "framer-motion";
import { useState, FC, useEffect, useRef } from "react";
import { useMobile } from "../../MobileProvider";
import { UserCircleIcon } from "@heroicons/react/24/solid";
import TeamItemStyled from "./TeamItemStyled";
import HoverBackground from "./HoverBackground";
import HoverWrapper from "./HoverWrapper";
import Name from "./Name";
import { useApp } from "../../AppProvider";

const TeamItemPlaceholderStyled = styled(TeamItemStyled)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#000",
}));

const PlaceholderButton = styled("button")(() => ({
  border: "1px solid #fff",
  backgroundColor: "rgba(255,255,255,.3)",
  padding: "1.5rem 1rem",
  borderRadius: 12,
  color: "#fff",
  cursor: "pointer",
  marginTop: "auto",
  fontWeight: "bold",
}));

const TeamPlaceholder: FC<{ handleKontaktformular: () => void }> = ({
  handleKontaktformular,
}) => {
  const [show, setShow] = useState<boolean>(false);
  const mobile = useMobile();
  const { analytics } = useApp();
  const ref = useRef<HTMLDivElement | null>(null);
  const isInview = useInView(ref, { margin: "-50% 0% -50% 0%" });

  useEffect(() => {
    if (isInview && mobile) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [isInview, mobile]);

  const handleMouseEnter = () => {
    setShow(true);
    if (analytics) {
      logEvent(analytics, "team_item_mouse_enter", {
        event_label: "placeholder",
      });
    }
  };

  const handleClick = () => {
    handleKontaktformular();
    if (analytics) {
      logEvent(analytics, "team_item_click", {
        event_label: "placeholder",
      });
    }
  };

  return (
    <TeamItemPlaceholderStyled
      ref={ref}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true }}
      initial={{ y: "20%", opacity: 0 }}
      transition={{ delay: 0.1, duration: 0.4 }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShow(false)}
    >
      <UserCircleIcon style={{ color: "#fff", width: 200, height: 200 }} />
      <AnimatePresence>
        {show && (
          <HoverBackground
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ delay: mobile ? 0.6 : 0 }}
          />
        )}
      </AnimatePresence>
      <AnimatePresence>
        {show && (
          <HoverWrapper
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{
              delay: mobile ? 0.7 : 0.1,
              duration: 0.3,
              stiffness: 200,
              damping: 30,
              type: "spring",
            }}
          >
            <Name>Du?</Name>
            <p style={{ color: "#fff", fontWeight: "bold" }}>
              Werde Teil unseres Teams!
            </p>
            <PlaceholderButton type={"button"} onClick={handleClick}>
              Jetzt bewerben!
            </PlaceholderButton>
          </HoverWrapper>
        )}
      </AnimatePresence>
    </TeamItemPlaceholderStyled>
  );
};

export default TeamPlaceholder;
